module.exports = __webpack_public_path__ + "static/media/outkast-aquemini.246c7b47.jpeg";